import {
    DEFAULT_CURRENCY,
    TRANSACTION_STATUS,
    TRANSACTION_TYPE,
} from '../../../utils/constants/commonValues';

function TransactionStatusData(data) {
    this.details = data && this.createData(data);
}

TransactionStatusData.prototype = Object.assign(
    TransactionStatusData.prototype,
    {
        createData(data) {
            const viewDetails = {
                statusMessage: '',
                transactionAmount: '',
                currency: '',
                orderId: '',
                statusCode: '',
                surchargeInfo: null,
                tags: null,
                transactionReferenceNumber: null,
                transactionType: '',
            };
            const { ltxnStatusInfo, transactionStatus } = data;
            if (ltxnStatusInfo && ltxnStatusInfo.data) {
                const { data, statusMessage, statusCode } = ltxnStatusInfo;
                const {
                    amount,
                    currency,
                    merchantTxnId,
                    surchargeInfo,
                    tags,
                    txnReferenceId,
                    txnType,
                } = data;
                viewDetails.statusMessage = statusMessage || '';
                viewDetails.statusCode = statusCode || '';
                viewDetails.transactionAmount = amount
                    ? `${DEFAULT_CURRENCY} ${amount}`
                    : '';
                viewDetails.currency = currency || '';
                viewDetails.orderId = merchantTxnId || '';
                viewDetails.surchargeInfo = surchargeInfo || '';
                viewDetails.tags = tags || '';
                viewDetails.transactionReferenceNumber = txnReferenceId || '';
                viewDetails.transactionType = this.getTransactionType(txnType);
            }
            return {
                ...viewDetails,
                transactionStatus: this.getTransactionStatus(transactionStatus),
            };
        },
        getTransactionStatus(status) {
            if (!status) {
                return '';
            }
            return TRANSACTION_STATUS[status];
        },
        getTransactionType(type) {
            if (!type) {
                return '';
            }

            return TRANSACTION_TYPE[type];
        },
    }
);

export default TransactionStatusData;
